<div class="change-nugget-preview" (click)="open($event)">
      <span class="circle-actions" i18n-ngbTooltip ngbTooltip="Change Preview" container="body"><i
                  class="fas fa-images"></i></span>
</div>
